import { useState } from 'react';

import { Dialog } from '../../common/Dialog';
import { CheckInTypeEnum } from '../../pages/Check-In/types/types';

import { AdhocUpdateCard } from './AdhocUpdates/AdhocUpdateCard';
import { AdhocUpdateDetailView } from './AdhocUpdates/AdhocUpdateDetailView';
import { TicketUpdateCard } from './TicketUpdates/TicketUpdateCard';
import { TicketUpdateDetailView } from './TicketUpdates/TicketUpdateDetailView';
import { ProgressUpdateCardProps } from './types';

export function ProgressUpdateCard({
  item,
  hideMenu = false,
  className = '',
  onEdit,
  onDelete,
  showDescription = false,
  actionButton,
  hidePopover = false,
}: ProgressUpdateCardProps): JSX.Element {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleClose = (): void => setIsDialogOpen(false);
  const handleOpen = (): void => setIsDialogOpen(true);

  return (
    <>
      <div className={`w-full ${className} text-[#434343]`}>
        {item.type === CheckInTypeEnum.TICKET ? (
          <TicketUpdateCard
            item={item}
            hideMenu={hideMenu}
            onEdit={onEdit}
            onDelete={onDelete}
            onClick={handleOpen}
            showDescription={showDescription}
            actionButton={actionButton}
            hidePopover={hidePopover}
          />
        ) : (
          <AdhocUpdateCard
            item={item}
            hideMenu={hideMenu}
            showDescription={showDescription}
            onEdit={onEdit}
            onDelete={onDelete}
            onClick={handleOpen}
            actionButton={actionButton}
          />
        )}
      </div>

      <Dialog
        isOpen={isDialogOpen}
        onClose={handleClose}
        title={item.title}
        titleLink={
          item.type === CheckInTypeEnum.TICKET ? item?.externalLink : undefined
        }
      >
        {item.type === 'ticket' ? (
          <TicketUpdateDetailView item={item} />
        ) : (
          <AdhocUpdateDetailView item={item} />
        )}
      </Dialog>
    </>
  );
}
